import { Injectable, ComponentRef, Type, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  show = false;
  constructor(){

  }


  // private modalComponentRef!: ComponentRef<any> | null;

  // constructor() {}

  // open(viewContainerRef: ViewContainerRef, component: Type<any>, props = {}) {
  //   viewContainerRef.clear();
  //   const componentRef = viewContainerRef.createComponent(component);
  //   Object.assign(componentRef.instance, props);
  //   this.modalComponentRef = componentRef;
  // }

  // close(viewContainerRef: ViewContainerRef) {
  //   if (this.modalComponentRef) {
  //     viewContainerRef.clear();
  //     this.modalComponentRef = null;
  //   }
  // }
}
